import { useState } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { Alert, Button, CircularProgress, Stack, TextField, Typography } from '@mui/material';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';
import { usePermissions } from '../contexts/PermissionContext';
import { useTenant } from '../contexts/TenantContext';
export default function Entry() {
  const { user } = useAuth();
  const { loading, hasPermission } = usePermissions();
  const tenant = useTenant();
  const [organization, setOrganization] = useState('');
  if (!user) return <Navigate to="/login" replace />;
  if (loading || tenant.loading) return <CircularProgress aria-label="Checking access" />;
  return <Stack spacing={3} alignItems="center" sx={{p:6}}>
    <Typography variant="h4">Welcome to Spark CRM</Typography>
    {!tenant.organizationId ? <>
      <Alert severity="warning">{tenant.error || 'Choose your organization to continue.'}</Alert>
      <Typography>Your organization ID is supplied by your administrator. Selecting it does not grant access.</Typography>
      <TextField label="Organization ID" value={organization} onChange={e => setOrganization(e.target.value)} />
      <Button variant="contained" onClick={() => tenant.selectOrganization(organization)}>Verify organization access</Button>
    </> : <>
      <Typography>Organization: {tenant.organizationId}</Typography>
      {hasPermission('CRM_DASHBOARD_VIEW') ? <Button component={Link} to="/" variant="contained">CRM Dashboard</Button>
        : <Alert severity="warning">Dashboard permission is not available for this account in the selected organization.</Alert>}
      {hasPermission('SYS_ADMIN_ACCESS') && hasPermission('SYS_ADMIN_ACCESS_ALL') && <Button component={Link} to="/super-admin" variant="outlined">Master Admin</Button>}
    </>}
    <Button onClick={() => signOut(auth)}>Sign out</Button>
  </Stack>;
}
